// Translations
import landing from '../views/landing/translations/en'

// Translation: Reset (English)
export default Object.freeze({
	name: 'Reset',
	views: { landing }
})
